export { default } from '../client/link';
export * from '../client/link';

//# sourceMappingURL=link.js.map